import React from 'react'
import "./Components.css"

const Footer = () => {
    return (
      <div className="footer">
        <div className="footer-info">
          <p>
            Created By <span className="vishal">Vishal Singh</span> | &copy; 2021 All rights
            reserved.
          </p>
        </div>
      </div>
    );
}

export default Footer
